/**
 * @desc selectByPonoAndSku
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<Array<defs.tms.StockOccupyMasterResponseRpcDto>>;
export function request(
  params: API.tms.stockOccupyFacadeImpl.selectByPonoAndSku.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/stockOccupy/selectByPonoAndSku`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
